import { defineMessages } from "react-intl";

export const messages = defineMessages({
  media: {
    id: "/Mcvt4",
    defaultMessage: "Media",
    description: "section header",
  },
  upload: {
    id: "mGiA6q",
    defaultMessage: "Upload",
    description: "modal button upload",
  },
  uploadImages: {
    id: "9CEu8k",
    defaultMessage: "Upload Images",
    description: "modal button images upload",
  },
  uploadUrl: {
    id: "Q2UXlW",
    defaultMessage: "Upload URL",
    description: "modal button url upload",
  },
});
